"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_state_tree_1 = require("mobx-state-tree");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var RuleConstants_1 = require("../../definitions/constants/RuleConstants");

var RuleConditionOptions_1 = __importDefault(require("../../definitions/constants/RuleConditionOptions"));

var PropertyModelSpec_1 = require("../../definitions/properties/PropertyModelSpec");

var GRAND_PARENT_LEVEL = 4;
var PARENT_LEVEL = 2;

var convertUIOperatorToNumericOperator = function convertUIOperatorToNumericOperator(value) {
  if (value === 'GT') {
    return '>';
  } else if (value === 'GTE') {
    return '>=';
  } else if (value === 'LT') {
    return '<';
  } else if (value === 'LTE') {
    return '<=';
  } else if (value === 'ET') {
    return '==';
  } else if (value === 'IT') {
    return 'inTop';
  } else if (value === 'IB') {
    return 'inBottom';
  } else if (value === 'MI') {
    return 'missing';
  }

  return null;
};

var convertNumericOperatorToUIOperator = function convertNumericOperatorToUIOperator(operator) {
  if (operator === '>') {
    return 'GT';
  } else if (operator === '>=') {
    return 'GTE';
  } else if (operator === '<') {
    return 'LT';
  } else if (operator === '<=') {
    return 'LTE';
  } else if (operator === '==') {
    return 'ET';
  } else if (operator === 'inTop') {
    return 'IT';
  } else if (operator === 'inBottom') {
    return 'IB';
  } else if (operator === 'missing') {
    return 'MI';
  }

  return null;
};

var getDropdown = function getDropdown(ddoptions, currentType) {
  var selectedObj = ddoptions.find(function (element) {
    return element.value === currentType;
  });
  return selectedObj === null || selectedObj === void 0 ? void 0 : selectedObj.paired.map(function (element) {
    return {
      value: element,
      label: StringResources_1.default.get("conditionalFormatting" + element)
    };
  });
};

var ConditionModelFactory = mobx_state_tree_1.types.model('Condition', {
  type: mobx_state_tree_1.types.maybeNull(mobx_state_tree_1.types.string),
  value: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.number) // This is an optional value in content model

}).actions(function (self) {
  return {
    setType: function setType(value) {
      self.type = convertUIOperatorToNumericOperator(value);
    },
    setValue: function setValue(value) {
      self.value = value;
    }
  };
}).views(function (self) {
  return {
    getType: function getType() {
      return self.type;
    },
    getValue: function getValue() {
      return self.value;
    },

    get conditionType() {
      return convertNumericOperatorToUIOperator(self.type);
    }

  };
});
exports.ConditionModelFactory = ConditionModelFactory;
var RuleStyleModelFactory = mobx_state_tree_1.types.model('RuleStyleModel', {
  textColor: mobx_state_tree_1.types.string,
  fillColor: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
  shape: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
  textHexColor: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.string, ''),
  fillHexColor: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.string, ''),
  fillPattern: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.string, '')
}).actions(function (self) {
  return {
    setTextColor: function setTextColor(value) {
      self.textColor = value;
    },
    setFillColor: function setFillColor(value) {
      self.fillColor = value;
    },
    setShape: function setShape(value) {
      self.shape = value;
    },
    setTextHexColor: function setTextHexColor(value) {
      self.textHexColor = value;
    },
    setFillHexColor: function setFillHexColor(value) {
      self.fillHexColor = value;
    },
    setFillPattern: function setFillPattern(value) {
      self.fillPattern = value;
    }
  };
}).views(function (self) {
  return {
    getTextColor: function getTextColor() {
      return self.textColor;
    },
    getFillColor: function getFillColor() {
      return self.fillColor;
    },
    getShape: function getShape() {
      return self.shape;
    },
    getTextHexColor: function getTextHexColor() {
      return self.textHexColor;
    },
    getFillHexColor: function getFillHexColor() {
      return self.fillHexColor;
    },
    getFillPattern: function getFillPattern() {
      return self.fillPattern;
    },

    get hasTextHexColor() {
      return self.textHexColor && self.textHexColor.length > 0;
    },

    get hasFillColor() {
      return self.fillColor && self.fillColor.length > 0;
    },

    get hasShape() {
      return self.shape && self.shape !== 'none';
    }

  };
});
exports.RuleStyleModelFactory = RuleStyleModelFactory;
/**
 * Creates an instance of a Rule, a conditional formatting property
 * @param ruleProps
 */

var RuleModelFactory = mobx_state_tree_1.types.model('RuleModel', {
  ruleType: mobx_state_tree_1.types.string,
  startCondition: ConditionModelFactory,
  endCondition: mobx_state_tree_1.types.maybeNull(ConditionModelFactory),
  ruleStyle: RuleStyleModelFactory,
  operator: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
  expand: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.boolean, false)
}).volatile(function () {
  return {
    parent: null,
    grandParent: null,
    dropdownOptions: null,
    startConditionOptions: null,
    endConditionOptions: null
  };
}).actions(function (self) {
  return {
    setStartConditionOptions: function setStartConditionOptions() {
      self.startConditionOptions = getDropdown(self.dropdownOptions, undefined);
    },
    setEndConditionOptions: function setEndConditionOptions() {
      self.endConditionOptions = getDropdown(self.dropdownOptions, self.startCondition.conditionType);
    }
  };
}).actions(function (self) {
  return {
    afterCreate: function afterCreate() {
      self.parent = mobx_state_tree_1.getParent(self, PARENT_LEVEL);
      self.grandParent = mobx_state_tree_1.getParent(self, GRAND_PARENT_LEVEL);
    },
    setConditionTypeOptions: function setConditionTypeOptions(scale) {
      self.dropdownOptions = RuleConditionOptions_1.default.getRuleOptionsBaseOnVisType(self.grandParent.uiContext.isKpiVis(), scale);
      self.setStartConditionOptions();
      self.setEndConditionOptions();
    },
    setExpand: function setExpand(callFrom, ruleIndex, expandState) {
      self.expand = expandState;
      self.grandParent.uiContext.setExpandRuleFlag(callFrom, self.parent.getDataItemId(), ruleIndex, expandState);
    },

    /**
     * Sets the start condition type
     * @param {number} index which rule in the array is being modified
     * @param {string} type the Condition type to be applied
     */
    setStartType: function setStartType(index, type) {
      // self.startCondition.setType(type);
      if (self.startCondition.type !== type) {
        self.grandParent.getConditionalFormattingApi().setRuleStartConditionType(self.parent.getDataItemId(), index, convertUIOperatorToNumericOperator(type));
      }
    },

    /**
     * Sets the start condition value
     * @param {number} index which rule in the array is being modified
     * @param {number} value the Condition value to be applied
     */
    setStartValue: function setStartValue(index, value) {
      if (self.startCondition.value !== value) {
        self.grandParent.getConditionalFormattingApi().setRuleStartConditionValue(self.parent.getDataItemId(), index, value);
      }
    },

    /**
     * Sets the end condition type
     * @param {number} index which rule in the array is being modified
     * @param {string} type the Condition type to be applied
     */
    setEndType: function setEndType(index, type) {
      if (self.endCondition.type !== type) {
        self.grandParent.getConditionalFormattingApi().setRuleEndConditionType(self.parent.getDataItemId(), index, convertUIOperatorToNumericOperator(type));
      }
    },

    /**
     * Sets the end condition value
     * @param {number} index which rule in the array is being modified
     * @param {number} value the Condition value to be applied
     */
    setEndValue: function setEndValue(index, value) {
      if (self.endCondition.value !== value) {
        self.grandParent.getConditionalFormattingApi().setRuleEndConditionValue(self.parent.getDataItemId(), index, value);
      }
    },

    /**
     * sets the rulestyle fill color
     * @param {number} index which rule in the array is being modified
     * @param newColor
     */
    setFillColor: function setFillColor(index, newColor) {
      if (self.ruleStyle.fillColor !== newColor) {
        self.grandParent.getConditionalFormattingApi().setRuleStyleFillColor(self.parent.getDataItemId(), index, newColor);
      }
    },

    /**
     * sets the rulestyles text color
     * @param {number} index which rule in the array is being modified
     * @param newColor
     */
    setTextColor: function setTextColor(index, newColor) {
      if (self.ruleStyle.textColor !== newColor) {
        self.grandParent.getConditionalFormattingApi().setRuleStyleTextColor(self.parent.getDataItemId(), index, newColor);
      }
    },

    /**
     * sets the rulestyle shape
     * @param {number} index which rule in the array is being modified
     * @param newShape
     */
    setShape: function setShape(index, newShape) {
      if (self.ruleStyle.shape !== newShape) {
        self.grandParent.getConditionalFormattingApi().setRuleStyleShape(self.parent.getDataItemId(), index, newShape);
      }
    },

    /**
     * Sets the Operator
     * @param {number} index which rule in the array is being modified
     * @param {RangeOperators} operator the operation to be performed between the conditions
     */
    setOperator: function setOperator(index, operator) {
      if (self.operator !== operator) {
        self.grandParent.getConditionalFormattingApi().setRangeOperator(self.parent.getDataItemId(), index, operator);
      }
    },
    setTextHexColor: function setTextHexColor(value) {
      self.ruleStyle.setTextHexColor(value);
    },
    setFillHexColor: function setFillHexColor(value) {
      self.ruleStyle.setFillHexColor(value);
    },
    setFillPattern: function setFillPattern(value) {
      self.ruleStyle.setFillPattern(value);
    },

    /**
     * Sets the start condition type
     *
     * @param {string} type the start condition type
     */
    setStartConditionTypeValueFromContentModel: function setStartConditionTypeValueFromContentModel(type) {
      self.startCondition.type = type;
      self.setEndConditionOptions();
    },

    /**
     * Sets the start condition value
     *
     * @param {number} value the start condition value
     */
    setStartConditionValueValueFromContentModel: function setStartConditionValueValueFromContentModel(value) {
      self.startCondition.value = value;
    },

    /**
     * Sets the end condition type
     *
     * @param {string} type the end condition type
     */
    setEndConditionTypeValueFromContentModel: function setEndConditionTypeValueFromContentModel(type) {
      self.endCondition.type = type;
    },

    /**
     * Sets the end condition value
     *
     * @param {number} value the end condition value
     */
    setEndConditionValueValueFromContentModel: function setEndConditionValueValueFromContentModel(value) {
      self.endCondition.value = value;
    },

    /**
     * Sets the range operator. Creates the end condition if needed.
     *
     * @param {string} type range operator type
     */
    setRangeOperatorValueFromContentModel: function setRangeOperatorValueFromContentModel(type, endCondition) {
      self.operator = type;

      if (self.operator === RuleConstants_1.RangeOperators.and) {
        if (!(endCondition instanceof PropertyModelSpec_1.Condition)) {
          throw new Error('Invalid endCondition');
        }

        self.endCondition = ConditionModelFactory.create(endCondition.getMSTJsonSpec());
      } else {
        mobx_state_tree_1.destroy(self.endCondition);
      }
    },

    /**
     * Sets the fill color
     *
     * @param {string} color the fill color
     */
    setRuleStyleFillColorValueFromContentModel: function setRuleStyleFillColorValueFromContentModel(color) {
      self.ruleStyle.fillColor = color;
      self.ruleStyle.fillHexColor = '';
    },

    /**
     * Sets the text color
     *
     * @param {string} color the text color
     */
    setRuleStyleTextColorValueFromContentModel: function setRuleStyleTextColorValueFromContentModel(color) {
      self.ruleStyle.textColor = color;
      self.ruleStyle.textHexColor = '';
    },

    /**
     * Sets the shape
     *
     * @param {string} shape the shape
     */
    setRuleStyleShapeValueFromContentModel: function setRuleStyleShapeValueFromContentModel(shape) {
      self.ruleStyle.shape = shape;
    }
  };
}).views(function (self) {
  return {
    getExpand: function getExpand() {
      return self.expand;
    },
    getStartCondition: function getStartCondition() {
      return self.startCondition;
    },
    getEndCondition: function getEndCondition() {
      return self.endCondition;
    },
    getTextColor: function getTextColor() {
      return self.ruleStyle.getTextColor();
    },
    getFillColor: function getFillColor() {
      return self.ruleStyle.getFillColor();
    },
    getShape: function getShape() {
      return self.ruleStyle.getShape();
    },
    getOperator: function getOperator() {
      return self.operator;
    },
    getTextHexColor: function getTextHexColor() {
      return self.ruleStyle.getTextHexColor();
    },
    getFillHexColor: function getFillHexColor() {
      return self.ruleStyle.getFillHexColor();
    },
    getFillPattern: function getFillPattern() {
      return self.ruleStyle.getFillPattern();
    },
    getConditionLabels: function getConditionLabels(condition) {
      if (condition && condition.conditionType) {
        var type = condition.conditionType;
        var spec = self.grandParent.getConditionalFormattingApi().getDataItemFormatSpec(self.parent.getDataItemId());

        if (type && type.length > 0) {
          return {
            type: StringResources_1.default.get("conditionalFormatting" + type),
            value: self.grandParent.getUIContext().format(condition.value, spec)
          };
        }
      }

      return null;
    },
    getStartConditionOptions: function getStartConditionOptions() {
      if (!self.startConditionOptions) {
        self.setConditionTypeOptions(self.parent.getScale());
      }

      return self.startConditionOptions;
    },
    getEndConditionOptions: function getEndConditionOptions() {
      if (!self.endConditionOptions) {
        self.setConditionTypeOptions(self.parent.getScale());
      }

      return self.endConditionOptions;
    },

    get hasEndCondition() {
      return !!self.endCondition;
    },

    get hasTextHexColor() {
      return self.ruleStyle.hasTextHexColor;
    },

    get hasFillColor() {
      return self.ruleStyle.hasFillColor;
    },

    get hasFillPattern() {
      return !!this.getFillPattern();
    },

    get hasShape() {
      return self.ruleStyle.hasShape;
    },

    get hasOperator() {
      return self.operator !== RuleConstants_1.RangeOperators.none;
    },

    get label() {
      var startLabels = this.getConditionLabels(self.startCondition);
      var endLabels = this.getConditionLabels(self.endCondition);

      if (endLabels) {
        return StringResources_1.default.get('conditionalFormattingAndRuleConditionLabel', {
          startType: startLabels.type,
          startValue: startLabels.value,
          endType: endLabels.type,
          endValue: endLabels.value
        });
      } else if (startLabels) {
        return StringResources_1.default.get('conditionalFormattingRuleConditionLabel', {
          type: startLabels.type,
          value: startLabels.value
        });
      }

      return null;
    },

    get startConditionValue() {
      return self.parent.getFormattedValue(self.startCondition.getValue());
    },

    get endConditionValue() {
      return self.parent.getFormattedValue(self.endCondition.getValue());
    },

    get dropDownValues() {
      return self.dropdownOptions.map(function (option) {
        return option.value;
      });
    }

  };
});
exports.default = RuleModelFactory;
